import netflix from './netflix.png';
import craveTv from './cravetv.png';
import amazonPrimeVideo from './amazon-prime-video.png';
import theMovieNetworkGo from './the-movie-network-go.png';
import appleItunes from './apple-itunes.png';
import googlePlayMovies from './google-play-movies.png';
import hoopla from './hoopla.png';
import icitouTv from './icitoutv.png';
import cineplex from './cineplex.png';
import tubiTv from './tubi-tv.png';
import playstation from './playstation.png';
import microsoftStore from './microsoft-store.png';
import hollywoodSuite from './hollywood-suite.png';
import fandor from './fandor.png';
import acornTv from './acorn-tv.png';
import sundanceNow from './sundance-now.png';
import shudder from './shudder.png';
import youtube from './youtube.png';
import mubi from './mubi.png';
import youtubePremium from './youtube-premium.png';
import guidedoc from './guidedoc.png';
import netflixKids from './netflix-kids.png';
import movietickets from './movietickets.png';
import britbox from './britbox.png';


export const nfx = netflix;
export const ctv = craveTv;
export const prv = amazonPrimeVideo;
export const tng = theMovieNetworkGo;
export const itu = appleItunes;
export const ply = googlePlayMovies;
export const hop = hoopla;
export const itt = icitouTv;
export const cpx = cineplex;
export const tbv = tubiTv;
export const pls = playstation;
export const msf = microsoftStore;
export const hws = hollywoodSuite;
export const fnd = fandor;
export const act = acornTv;
export const sdn = sundanceNow;
export const shd = shudder;
export const yot = youtube;
export const mbi = mubi;
export const ytr = youtubePremium;
export const gdc = guidedoc;
export const nfk = netflixKids;
export const mts = movietickets;
export const bbo = britbox;